import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectIdentifier} from "../../../../../../../../../core/shared/basic/object-identifier";
import {WidgetFactory} from "../../../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetDataParam} from "../../../../../../../../../core/shared/widget/widget-data-param";
import {QlQueryDto} from "../../../../../../../../../core/shared/ql/data/dto/ql-query.dto";
import {WidgetData} from "../../../../../../../../../core/shared/widget/widget-data";

@Component({
    selector: 'cm-contract-widget',
    templateUrl: './cm-contract-widget.component.html',
    standalone: false
})
export class CmContractWidgetComponent implements OnInit, OnChanges, OnDestroy {
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() isMinWidth: string;

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    contractWidgetData: WidgetData;
    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.createContractWidget();
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

    createContractWidget(){

        const alias = 'cm.contract.contracts.new';

        const qlQueryDto: QlQueryDto = {
            name: alias,
            type: 'view',
            fixedFilters: [FilterCriteria.create("e.id", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            start: {
                name: "cm.Contract",
                as: "e",
                type: "entity",
                joins: [
                    {
                        joinType: "left",
                        type: "meta",
                        name: "+agencyNumber",
                        as: "an"
                    },
                    {
                        joinType: "left",
                        type: "entity",
                        name: "partnerLink",
                        as: "pl",
                    },
                    {
                        joinType: "left",
                        type: "entity",
                        name: "rating",
                        as: "r",
                        fields:[
                            {
                                name:"name",

                            },
                            {
                                name:"image"
                            }
                        ]
                    }
                ],
                // parameters : [
                //     {
                //         "param": "resolve_fkey_texts",
                //         "value": "true"
                //     }]
            }
        };

        this.contractWidgetData = WidgetFactory.createWidgetListQl(
            alias,
            "Vertrag",
            "list",
            qlQueryDto
        )
        new WidgetDataParam("e.objectId", this.objectIdentifier.objectId)
    }
}
